var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "button",
    {
      staticClass: "cw-block-adder-area",
      class: {
        "cw-block-adder-active": _vm.adderActive
      },
      attrs: {
        "aria-pressed": _vm.adderActive
      },
      on: {
        click: _vm.selectBlockAdder
      }
    },
    [
      _c("studip-icon", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.adderActive,
            expression: "!adderActive"
          }
        ],
        attrs: {
          shape: "add"
        }
      }),
      _vm._v(" "),
      _c("studip-icon", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.adderActive,
            expression: "adderActive"
          }
        ],
        attrs: {
          shape: "add",
          role: "info_alt"
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.adderActive,
              expression: "!adderActive"
            }
          ]
        },
        [_c("translate", [_vm._v("Block zu diesem Abschnitt hinzufügen")])],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.adderActive,
              expression: "adderActive"
            }
          ]
        },
        [
          _c("translate", [
            _vm._v("Abschnitt aktiv - Blöcke werden hier eingefügt")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }